module.exports = __webpack_public_path__ + "public/images/loyalty-bg.09a81537d7481b2c0f8b631425f7014c.svg";